import React from 'react';
import NavBar from '../components/common/NavBar';
import Footer from '../components/common/Footer';
import TopImage from "../components/common/TopImage";

const imageURL = process.env.PUBLIC_URL + "/assets/Houses";

const StudentLifePage = () => {
  return (
    <div >
      <NavBar />
      <TopImage text="House System"/>

<div className='justify-center text-center'>
    <p className="font-dm-sans mt-20 max-md:mt-8 max-md:mx-5 text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold leading-6 sm:leading-7 tracking-tight text-center">
    Experience the magic of student life
  </p>
</div>

<div className="mx-28 max-md:mx-5">
  <div>
    <p className="font-dm-sans text-sm mb-20 text-gray-700 sm:text-base md:text-lg lg:text-xl font-normal leading-6 sm:leading-7 tracking-tight text-justify mt-4 sm:mt-6 md:mt-8">
      At Motherland Children Academy, we understand that parents want the best for their child, and that's why we are all about giving your child a quality life. From a strong academic foundation to the development of your child's physical, spiritual, and emotional personality, the Motherland way is about holistic development in its true sense.
     <br></br> Here at Motherland, we have 4 different houses representing different attributes:

    </p>
  </div>

  <p className='font-dm-sans text-base sm:text-lg md:text-xl lg:text-4xl font-bold leading-6 sm:leading-7 tracking-tight text-center mt-6 sm:mt-10 md:mt-12'>
  <span className="text-red-500">PRITHVIRAJ</span> ,{' '}
  <span className="text-yellow-500">SHIVAJI</span> ,{' '}
  <span className="text-blue-500">ASHOKA</span> ,{' '}
  <span className="text-green-500">HARSHA</span>
</p>

</div>

      <div className="mt-20 mb-30 mx-5  flex justify-center items-center">
        {/* <img
          loading="lazy"
          src={imageURL + "/Combine.jpg"}
          alt="Combine House"
          className="max-w-full max-h-full "
        /> */}
       
        <img
          loading="lazy"
          src={imageURL + "/Combine.jpg"}
          alt="Combine House"
          className="max-w-full max-h-full mb-20 max-md:mb-8 "
        />

      </div>
     
      <Footer />
    </div>
  );
};

export default StudentLifePage;
